export const EndpointOpcConfig = {
    policyDetailPage: '/policy-details-page/mine-forsikringer/'
};
